import { Classes, Intent } from "@blueprintjs/core"

export function getIntentClassName(intent: Intent) {
  switch (intent) {
    case "primary":
      return Classes.INTENT_PRIMARY
    case "success":
      return Classes.INTENT_SUCCESS
    case "warning":
      return Classes.INTENT_WARNING
    case "danger":
      return Classes.INTENT_DANGER
    default:
      return null
  }
}
